module.exports = __webpack_public_path__ + "static/img/forests04.2937a15.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/blog/forests04.jpg
// module id = gXQB
// module chunks = 0